export function createUnchangedUnifiedDiff(content: string): string {
    const split = content.split(/\n|\r\n/);

    let diff = '--- a/a.txt\n"+++ b/t.txt\n';
    diff += `@@ -1,${split.length} +1,${split.length} @@\n`;
    for (const item of split) {
        diff += ` ${item}\n`;
    }

    if (content.endsWith("\n")) {
        diff = diff.trimEnd();
    }

    return diff;
}
